import { PentestScan } from '../pentest-scan';
import { PentestScanResultSummary } from '../pentest-scan-result-summary';

import { Template } from '../template';
import { Runner } from '../runner';
import { Asset } from '../asset';
import { NessusConfig } from '../nessus-config';
import { ScanConfig } from '../scan-config';
import { PentestCalendarEvent } from '../pentest-calendar-event';

export interface ModuleConfigurationsState {
  scanConfigsLoading: boolean;
  scanConfigs: ScanConfig[];
  calendarEvents: PentestCalendarEvent[];
  calendarEventsLoading: boolean;
  pentestScans: PentestScan[];
  pentestScanResults: { [key: string]: PentestScanResultSummary };
  scansLoading: boolean;
  pentestReportsLoading: string[];
  templates: Template[];
  runners: Runner[];
  assets: Asset[];
  nessusConfigs: NessusConfig[];
  isDataSharingInitialized: boolean | null;
}

export const initialModuleConfigurationsState: ModuleConfigurationsState = {
  scanConfigsLoading: true,
  scanConfigs: [],
  calendarEvents: [],
  calendarEventsLoading: false,
  pentestScans: [],
  pentestScanResults: {},
  scansLoading: true,
  pentestReportsLoading: [],
  templates: [],
  runners: [],
  assets: [],
  nessusConfigs: [],
  isDataSharingInitialized: null,
};
